import { customersFeaturesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { IdType } from "../env";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("customer-features"),
  endpoint: "customers/features",
  operations: customersFeaturesOps,
  getDetailEndpoint: (id: IdType) => `customers/${id}/features`,
  roleView: [ROLE.FEATURE_VIEW, ROLE.FEATURE_ADMIN],
  roleAdmin: [ROLE.FEATURE_ADMIN],
  baseRoute: "customer-features",
  singularName: (t) => t("Customer features"),
  name: (t) => t("Customer features"),
  noIdInCall: true,
  noIdInUrl: true,
  dependencies: ["customer"],
  syncCustomerFilter: true,
});

export default conf;
